import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'

function Header() {
  const [isScrolled, setIsScrolled] = useState(window.location.pathname !== '/');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [navTop, setNavTop] = useState(45);
  const [navHeight, setNavHeight] = useState(80);
  const navRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      // Force scrolled state (white back, blue text) if not on home page
      if (location.pathname !== '/') {
        setIsScrolled(true);
      } else {
        if (window.scrollY > 45) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      }
    };
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    // Initial check
    handleResize();
    handleScroll(); // Force the layout immediately based on pathname
    handleScroll(); // Force the layout immediately based on pathname

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  // Measure nav height for spacer
  useEffect(() => {
    if (!isHomePage && navRef.current) {
      const measure = () => setNavHeight(navRef.current?.offsetHeight || 80);
      measure();
      const ro = new ResizeObserver(measure);
      ro.observe(navRef.current);
      return () => ro.disconnect();
    }
  }, [isHomePage]);

  // Dynamically position nav below topbar until topbar scrolls away
  useEffect(() => {
    if (isHomePage) return;
    const update = () => {
      const topbarH = window.innerWidth >= 768 ? 45 : 0;
      setNavTop(Math.max(0, topbarH - window.scrollY));
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [isHomePage]);

  const handleNavClick = (path) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
      const navbarCollapse = document.getElementById('navbarCollapse');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, {
        toggle: false
      });
      bsCollapse.hide();
    }
    
    
    navigate(path);
  };

  const topbarJSX = (
    <div className="container-fluid d-none d-md-block topbar-only" style={{ backgroundColor: '#001437' }}>
      <div className="container">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
          <div className="d-inline-flex align-items-center" style={{ height: 45 }}>
            <small className="me-3 text-light"><i className="fa fa-map-marker-alt me-2" />32,Avenue Hédi Nouira -Ennasr 2, Ariana Tunis</small>
            <small className="me-3 text-light"><i className="fa fa-phone-alt me-2" />+216 29 308 000</small>
            <small className="text-light"><i className="fa fa-envelope-open me-2" />booking@aviatortravel.tn</small>
          </div>
        </div>
        <div className="col-lg-4 text-center text-lg-end">
          <div className="d-inline-flex align-items-center" style={{ height: 45 }}>
            <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="https://www.facebook.com/AVIATORTN/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f fw-normal" /></a>
            <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="https://www.instagram.com/aviator_travel_services/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram fw-normal" /></a>
            <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href=""><i className="fab fa-youtube fw-normal" /></a>
          </div>
        </div>
      </div>
      </div>
    </div>
  );

  const navJSX = (
    <nav className={`navbar navbar-expand-lg py-3 py-lg-0 ${(isScrolled || isMobile || !isHomePage) ? 'navbar-light bg-white' : 'navbar-dark'}`} style={{ backgroundColor: (isScrolled || isMobile || !isHomePage) ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}>
      <div className="container">
        <Link to="/" className="navbar-brand p-0" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <h1 className="text-primary m-0">
            <img id="brand-logo" src={(isScrolled || isMobile) ? "/assets/img/logo2.png" : "/assets/img/logo3.png"} alt="Aviator Travel Service" />
          </h1>
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
          <span className="fa fa-bars" />
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav mx-auto py-0">
            <Link to="/" className="nav-item nav-link" onClick={() => handleNavClick('/')}>Accueil</Link>
            <Link to="/services" className="nav-item nav-link" onClick={() => handleNavClick('/services')}>Nos services</Link>
            <Link to="/billets" className="nav-item nav-link" onClick={() => handleNavClick('/billets')}>Billets d'avion</Link>
            <Link to="/hotelstn" className="nav-item nav-link" onClick={() => handleNavClick('/hotelstn')}>Hôtels en tunisie</Link>
            <div className="nav-item dropdown">
              <Link to="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Voyages à l'étranger</Link>
              <div className="dropdown-menu m-0">
                <Link to="/Voyage" className="dropdown-item" onClick={() => handleNavClick('/Voyage')}>Voyages Organisés</Link>
                <Link to="/carte" className="dropdown-item" onClick={() => handleNavClick('/carte')}>A la carte</Link>
              </div>
            </div>
            <div className="nav-item dropdown">
              <Link to="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Sports</Link>
              <div className="dropdown-menu m-0">
                <Link to="/sport" className="dropdown-item" onClick={() => handleNavClick('/sport')}>Événements sportifs</Link>
                <Link to="/coupe" className="dropdown-item" onClick={() => handleNavClick('/coupe')}>Coupe du monde</Link>
              </div>
            </div>
            <Link to="/omra" className="nav-item nav-link" onClick={() => handleNavClick('/omra')}>Omra</Link>
            <Link to="/Contact" className="nav-item nav-link" onClick={() => handleNavClick('/Contact')}>Contact</Link>
          </div>
          <Link
            to="/login"
            className="btn btn-primary rounded-pill py-2 px-4"
            style={{ backgroundColor: '#001437', borderColor: '#001437', color: 'white', fontWeight: '500' }}
            onClick={() => handleNavClick('/login')}
            onMouseEnter={e => e.currentTarget.style.color = '#FFBC1E'}
            onMouseLeave={e => e.currentTarget.style.color = 'white'}
          >
            Espace Professionnel
          </Link>
        </div>
      </div>
    </nav>
  );

  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
      <style>
        {`
        /* ============================================= */
/* HEADER NAVIGATION IMPROVEMENTS */
/* ============================================= */

/* Reduce logo size and add spacing */
.navbar-brand h1 {
  margin: 0 !important;
}

img#brand-logo {
  height: 75px !important;
  max-height: 75px !important;
  width: auto !important;
  object-fit: contain;
  transition: opacity 0.3s ease !important;
}

/* Remove that forced margin so mx-auto can center the nav */
.navbar-nav {
  margin: 0 auto !important;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px; /* Default space */
}

/* Base link sizes */
.navbar-nav .nav-link {
  font-size: 16px !important;
  padding: 8px 10px !important;
  font-weight: 500 !important;
  white-space: nowrap;
  transition: color 0.3s ease;
}

@media (min-width: 992px) {
  .navbar-collapse {
    justify-content: space-between;
  }
  
  .navbar-nav {
    flex-wrap: nowrap !important; /* Force to stay on 1 single line */
    flex-direction: row !important; 
    justify-content: center;
    gap: 5px !important; /* Save space so nothing overflows */
  }
  
  /* Remove fixed 250px width - this removes the empty massive space on the left! */
  .navbar-brand {
    width: auto !important; 
    margin-right: 15px;
    display: flex;
  }
  
  /* Reduce button size requirement to let links breathe */
  .navbar .btn-primary {
    min-width: auto;
    text-align: center;
  }

  /* Shrink links significantly on medium screens (Tablet Landscape 992 to 1200) to guarantee 1 single line */
  .navbar-nav .nav-link {
    font-size: 12px !important;
    padding: 6px 5px !important;
  }

  img#brand-logo {
    height: 60px !important;
    max-height: 60px !important;
  }

  .navbar .btn-primary {
    font-size: 11px !important;
    padding: 6px 10px !important;
    margin-left: 5px !important;
  }
}

@media (min-width: 1200px) {
  .navbar-nav {
    gap: 8px !important; 
  }
  .navbar-nav .nav-link {
    font-size: 14px !important;
    padding: 8px 8px !important;
  }
  .navbar-brand {
    margin-right: 15px;
  }
  img#brand-logo {
    height: 55px !important;
    max-height: 55px !important;
  }
}

@media (min-width: 1400px) {
  .navbar-nav {
    gap: 15px !important;
  }
  .navbar-nav .nav-link {
    font-size: 16px !important;
    padding: 8px 12px !important;
  }
  .navbar-brand {
    margin-right: 30px;
  }
  img#brand-logo {
    height: 68px !important;
    max-height: 68px !important;
  }
}

/* Default color (not scrolled) */
.navbar-dark .navbar-nav .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: white !important;
  margin: 0 !important;
}

/* Color override when scrolled */
.navbar-light .navbar-nav .nav-link,
.navbar-light .navbar-nav .nav-link.active,
.navbar-light .navbar-nav .nav-link:hover {
  color: #01225C !important;
  margin: 0 !important;
}

/* Adjust button size */
.navbar .btn-primary {
  font-size: 11px !important;
  padding: 8px 12px !important;
  white-space: nowrap;
  margin-left: 10px !important;
}

/* Better spacing for navbar */
.navbar {
  padding-top: 0.8rem !important;
  padding-bottom: 0.8rem !important;
}

/* ============================================= */
/* FORCE HAMBURGER MENU AT LARGER SCREENS */
/* ============================================= */

/* Hide desktop menu and show hamburger below 992px (Tablet) */
@media (max-width: 991px) {
  .navbar-toggler {
    display: block !important;
  }

  .navbar-collapse {
    display: none !important;
  }

  .navbar-collapse.show {
    display: block !important;
  }
  
  .navbar-nav {
    width: 100%;
    align-items: flex-start !important; /* Force left alignment */
    gap: 0px !important; /* Remove center gap logic */
    margin-left: 0 !important;
    margin-top: 15px !important;
  }

  .navbar-nav .nav-link {
    text-align: left !important;
    width: 100%;
    padding: 12px 0 !important;
    font-size: 15px !important;
    border-bottom: 1px solid #f0f0f0;
  }

  /* Logo adjustments when collapsed */
  img#brand-logo {
    height: 50px !important;
    max-height: 50px !important;
  }

  /* Button styling when collapsed */
  .navbar .btn-primary {
    margin-top: 15px !important;
    margin-left: 0 !important;
    width: 100% !important;
    padding: 12px !important;
    font-size: 14px !important;
  }

  /* Navbar padding when collapsed */
  .navbar {
    padding: 15px 20px !important;
  }

  /* Dropdown menu full width when collapsed */
  .navbar-nav .dropdown-menu {
    width: 100% !important;
    border: none !important;
    box-shadow: none !important;
    padding-left: 20px !important;
  }

  .navbar-nav .dropdown-item {
    padding: 10px 0 !important;
    font-size: 14px !important;
  }
}

/* ============================================= */
/* DESKTOP VIEW (≥992px) - Everything visible */
/* ============================================= */
@media (min-width: 992px) {
  .navbar-toggler {
    display: none !important;
  }

  .navbar-collapse {
    display: flex !important;
  }
}

/* ============================================= */
/* EXTRA LARGE SCREENS (≥1600px) - More space */
/* ============================================= */
@media (min-width: 1600px) {
  .navbar-nav .nav-link {
    font-size: 16px !important;
    padding: 8px 15px !important;
  }

  .navbar .btn-primary {
    font-size: 14px !important;
    padding: 8px 20px !important;
    margin-left: 15px !important;
  }

  img#brand-logo {
    height: 65px !important;
    max-height: 65px !important;
  }
}

/* ============================================= */
/* SMALL MOBILE (≤576px) */
/* ============================================= */
@media (max-width: 576px) {
  img#brand-logo {
    height: 45px !important;
    max-height: 45px !important;
  }

  .navbar {
    padding: 12px 15px !important;
  }

  .navbar-nav .nav-link {
    font-size: 16px !important;
    padding: 10px 0 !important;
  }
}

/* ============================================= */
/* TOPBAR RESPONSIVE */
/* ============================================= */
@media (max-width: 768px) {
  .topbar-only {
    display: none !important;
  }
}


/* ============================================= */
/* NAVBAR COLLAPSE SMOOTH ANIMATION */
/* ============================================= */
.navbar-collapse {
  transition: height 0.3s ease-in-out;
}

.navbar-collapse.collapsing {
  transition: height 0.3s ease;
}

/* ============================================= */
/* HOVER EFFECTS & DROPDOWNS */
/* ============================================= */

/* OPEN DROPDOWN ON HOVER (Desktop only) */
@media (min-width: 992px) {
  .navbar-nav .dropdown:hover .dropdown-menu {
    display: block;
    margin-top: 0;
  }
}

/* Border radius for dropdown menus */
.navbar-nav .dropdown-menu {
  border-radius: 3px !important;
  overflow: hidden; /* Ensures child elements respect the border radius */
}

.navbar-light .navbar-nav .nav-link:hover {
  color: #01225C !important;
  transition: color 0.3s ease;
}

.navbar-dark .navbar-nav .nav-link:hover {
  color: white !important;
  font-weight: bold !important;
  transition: all 0.2s ease;
}

.navbar .btn-primary:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

/* ============================================= */
/* ACTIVE LINK STYLING */
/* ============================================= */
.navbar-nav .nav-link.active {
  color: #2B4C7E !important;
  font-weight: 600 !important;
}

/* ============================================= */
/* FIX OVERFLOW & ABSOLUTE POSITIONING BUG */
/* ============================================= */

.navbar {
  overflow: visible !important;
}

        `}
      </style>
      {isHomePage ? (
        <>
          {topbarJSX}
          <div className={`container-fluid w-100 p-0 ${isScrolled ? 'position-fixed top-0 shadow' : 'position-absolute'}`} style={{ zIndex: 999, transition: 'all 0.3s ease' }}>
            {navJSX}
          </div>
        </>
      ) : (
        <>
          {topbarJSX}
          <div ref={navRef} className='position-fixed w-100' style={{ top: navTop, zIndex: 999, boxShadow: '0 2px 12px rgba(0,0,0,0.12)', transition: 'top 0.05s linear' }}>
            {navJSX}
          </div>
          <div style={{ height: navHeight }} />
        </>
      )}
    </div>
  )
}

export default Header